import React, { useCallback, useEffect } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';

const AppUrlListener: React.FC = () => {
  const navigate = useNavigate();

  const extractPathFromUrl = useCallback((url: string): string | undefined => {
    const { pathname, search } = new URL(url);
    return `${pathname}${search}`;
  }, []);

  useEffect(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const path = extractPathFromUrl(event.url);
      if (path) {
        navigate(path);
      }
    });
  }, [navigate, extractPathFromUrl]);

  return null;
};

export default AppUrlListener;
